<script>
import CommonBottomBar from "@/components/CommonBottomBar.vue";
import AppFeatureTabs from "@/views/About/components/AppFeatureTabs.vue";

export default {
  name: "aboutPage",
  components: {AppFeatureTabs, CommonBottomBar},
  data() {
    return {
      imgSrc: this.$i18n.locale === 'en' ? require('@/assets/images/about/Group 1091.png') : this.$i18n.locale === 'zh-CN' ? require('@/assets/images/about/app-intro-banner-SC.jpg') : require('@/assets/images/about/app-intro-banner-TC.jpg'),
      isImageLoaded: false,
      dialogVisible: false,
      currentVideoId: '',
      currentTab:0,
    }
  },
  created() {
    // 预加载图片
    this.preloadImage(this.imgSrc)
  },
  mounted() {
    this.scrollToHash()
  },
  watch: {
    // 监听路由变化（比如从其他页面跳过来）
    '$route'() {
      this.scrollToHash();
    }
  },
  methods: {
    preloadImage(src) {
      const img = new Image()
      img.onload = () => {
        this.isImageLoaded = true
      }
      img.src = src
    },
    scrollToHash(){
      const hash = this.$route.hash;
      if(hash){
        const refName = hash.substring(1)
        const element = this.$refs[refName]
        if(element){
          setTimeout(() => {
            window.scroll({
              top: element.offsetTop - 100,
              behavior: 'smooth'
            });
          }, 200); // 👈 关键：加一点延迟
        }
      }
    },
    currentChange(index){
      this.currentTab = index
    },
    openVideo(videoId){
      this.currentVideoId = videoId
      this.dialogVisible = true
    },
    closeDialog() {
      this.dialogVisible = false
      this.currentVideoId = ''
    },
  },
  computed:{
    registrationCards(){
      return [
        { title: this.$t('home.registration1'), videoId: 'https://www.youtube.com/embed/GdtX5lIh4fA?si=wpkaSabUwb-wabqV' },
        { title: this.$t('home.registration2'), videoId: 'https://www.youtube.com/embed/XiDsb8q1w_E?si=fD3jPe_x4Ir4z0wZ' },
        { title: this.$t('home.registration3'), videoId: 'https://www.youtube.com/embed/GdLsBkCVZ_M?si=v2tn1TPISzbqRag-' }
      ]
    },
    redemptionCards(){
      return [
        { title: this.$t('home.redemption1'), videoId: 'https://www.youtube.com/embed/OVKXEzAElT8?si=G9CsO_IVuR2JRrdv' },
        { title: this.$t('home.redemption2'), videoId: 'https://www.youtube.com/embed/hzNOamwVHsw?si=0gAhtmQzTSF04v5f' },
        { title: this.$t('home.redemption3'), videoId: 'https://www.youtube.com/embed/A-wl_9fHAgg?si=fQmzyt4ox4WguVqV' },
        { title: this.$t('home.redemption4'), videoId: 'https://www.youtube.com/embed/lmAoZOdbFG4?si=Kq5XqWLblJF4KwO0' },
        { title: this.$t('home.redemption5'), videoId: 'https://www.youtube.com/embed/QK9BHSpqSXE?si=WIJ6nrjjZ_M9laco' }
      ]
    },
    aboutImage(){
      return this.$i18n.locale === 'en' ? require('@/assets/images/about/Group 1091.png') : this.$i18n.locale === 'zh-CN' ? require('@/assets/images/about/app-intro-banner-SC.jpg') : require('@/assets/images/about/app-intro-banner-TC.jpg')
    },
    featureTab(){
      return [
        {
          icon: require('@/assets/images/about/Group 1101.png'),
          title:this.$t('home.monkeyCoin-Excursion')
        },
        {
          icon: require('@/assets/images/about/Group 1103.png'),
          title:this.$t('home.topUpCoinTitle')
        },
        {
          icon: require('@/assets/images/about/Group 1097.png'),
          title: this.$t('about.newFeatures3')
        },
        {
          icon: require('@/assets/images/about/Group 1099.png'),
          title: this.$t('home.top-cash')
        }
      ]
    }
  }
}
</script>

<template>
  <div class="about-container">
    <div class="big-image">
      <!-- 加载状态 -->
      <div v-if="!isImageLoaded" class="image-loading">
        <i class="el-icon-loading loading-icon"></i>
      </div>
      <!-- 图片加载完成后淡入 -->
      <el-image v-else :src="aboutImage" fit="contain" class="fade-in-image"/>
    </div>
    <div class="container">
<!--      <div class="about-wrap">-->
<!--        <div class="d-xs-none d-lg-block" style="margin-bottom: 37.5px;"><img style="width: 205px" class="mw-100 vertical-middle" src="@/assets/images/home/pp_logo_s.png" alt=""></div>-->
<!--        <h1>About Privilege Program</h1>-->
<!--        <div class="d-flex md-container" style="justify-content: space-between; margin-top: 10%">-->
<!--          <div style="flex: 1; text-align: center" class="d-xs-block d-lg-none"><img class="mw-100" src="@/assets/images/home/pp_logo_s.png" alt=""></div>-->
<!--          <div style="flex: 1" class="m-about">-->
<!--            <p>Our Privilege Program is crafted especially for kids and families to unlock a world of entertainment in Hong Kong. Enjoy incredible discounts, unbeatable market prices, and exceptional experiences that you and your children will cherish for a lifetime. Join us for an unforgettable adventure and make memories together!</p>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
      <div class="about-wrap">
        <div class="left-wrap">
          <h1>{{$t('home.aboutPPTitle')}}</h1>
          <p style="margin-bottom: 10%">
            {{$t('home.aboutPPIntro')}}
          </p>
          <el-divider class="d-xs-block d-lg-none"/>
        </div>
        <div class="right-wrap">
          <h1> {{$t('about.contact')}}</h1>
          <div class="mobile-content" style="display: flex; flex-direction: column; row-gap: 50px">
            <div class="item">
              <div><img class="vertical-middle" src="@/assets/images/about/Group 1037.svg" alt=""></div>
              <div>
                <p class="rs-title">{{$t('contact.email')}}</p>
                <p>enquiry@ppmember.com</p>
              </div>
            </div>
            <div class="item">
              <div><img class="vertical-middle" src="@/assets/images/about/Group 1039.svg" alt=""></div>
              <div>
                <p class="rs-title">{{$t('about.socialMedia')}}</p>
                <div style="display: flex; align-items: center;  column-gap: 10px">
                  <a href="https://www.facebook.com/MonkeyTreeEnglishLearningCenter" target="_blank"><img src="@/assets/images/footer/social_03_03.webp" alt="" class="mw-100"></a>
                  <a href="https://instagram.com/monkeytreehk" target="_blank"><img src="@/assets/images/footer/social_03_05.webp" alt="" class="mw-100"></a>
                  <a href="https://www.youtube.com/user/monkeytreehk" target="_blank"><img src="@/assets/images/footer/social_03_09.webp" alt="" class="mw-100"></a>
                </div>
              </div>
            </div>
            <div class="item">
              <div><img class="vertical-middle" src="@/assets/images/about/Group 1041.svg" alt=""></div>
              <div>
                <p class="rs-title">{{$t('about.down')}}</p>
                <div class="about-qr-box">
                  <div style="width: 152px">
                    <img src="@/assets/images/home/N_appIcon.webp" class="mw-100 vertical-middle" style="width: 100%" alt="">
                  </div>
                  <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; width: 115px">
                    <img src="@/assets/images/home/NEW_PP_Asset 348@3x.png" class="mw-100" alt="">
                    <img style="margin-top: 5%;" src="@/assets/images/home/NEW_PP_Asset 350@3x.png" class="mw-100" alt="">
                  </div>
                  <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; width: 115px">
                    <img src="@/assets/images/home/NEW_PP_Asset 348@3x.png" class="mw-100" alt="">
                    <img style="margin-top: 5%;" src="@/assets/images/home/NEW_PP_Asset 351@3x.png" class="mw-100" alt="">
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <section class="mt-app-wrap" ref="mt-app-section">
      <img class="d-xs-block d-xxl-none" style="vertical-align: middle; width: 100%" src="@/assets/images/partner/top-Asset 17.png" alt="">
      <div class="mt-app-intro-wrap">
        <img src="@/assets/images/mtapp/1.png" class="mw-100 d-xs-block d-xxl-none" style="width: 472px; position: absolute; top: -8%; left: 320px" alt="">
        <div class="top-box">
          <img class="d-xs-none d-xxl-block phone-img" src="@/assets/images/mtapp/1.png" alt="">
          <div class="right-box">
            <h1>Monkey Tree App</h1>
            <p>{{ $t('about.mtp1') }}<br> <br>
              {{ $t('about.mtp2') }}
              <br><br><br>
            </p>
          </div>
        </div>
        <div class="app-feature-wrap">
          <h1>{{ $t('about.AppFeatures') }}</h1>
<!--          <div class="feature-items">-->
<!--            <div class="item">-->
<!--              {{ $t('about.features1') }}-->
<!--            </div>-->
<!--            <hr class="divider d-xs-none d-lg-block" />-->
<!--            <div class="item">-->
<!--              {{ $t('about.features2') }}-->
<!--            </div>-->
<!--            <hr class="divider d-xs-none d-lg-block" />-->
<!--            <div class="item">-->
<!--              {{ $t('about.features3') }}-->
<!--            </div>-->
<!--            <hr class="divider d-xs-none d-lg-block" />-->
<!--            <div class="item">-->
<!--              {{ $t('about.features4') }}-->
<!--            </div>-->
<!--          </div>-->
          <app-feature-tabs :title="featureTab" @tab-change="currentChange">
            <div class="" v-show="currentTab === 0">
              <h1 class="tabs-title d-xs-block d-lg-none">{{$t('about.newFeatureTitle1')}}</h1>
              <div class="tabs-content">
                <img class="mw-100 m" src="@/assets/images/about/tab_img1.png" alt="">
                <h1 class="tabs-title d-lg-block d-xs-none">{{$t('about.newFeatureTitle1')}}</h1>
                <p style="white-space: pre-line" v-html="$t('about.newFeatureP1')"></p>
              </div>
            </div>
            <div v-show="currentTab === 1">
              <h1 class="tabs-title d-xs-block d-lg-none">{{$t('about.newFeatureTitle2')}}</h1>
              <div class="tabs-content">
                <img class="mw-100 m" src="@/assets/images/about/N_panel_4.webp" alt="">
                <h1 class="tabs-title d-lg-block d-xs-none">{{$t('about.newFeatureTitle2')}}</h1>
                <p>{{$t('about.newFeatureP2')}}</p>
              </div>
            </div>
            <div v-show="currentTab === 2">
              <h1 class="tabs-title d-xs-block d-lg-none">{{$t('about.newFeatureTitle3')}}</h1>
              <div class="tabs-content" style="width: 95%;flex-direction: column">
                <img class="mw-100 d-lg-block d-xs-none" src="@/assets/images/about/tab_img3.png" alt="">
                <h1 class="tabs-title d-lg-block d-xs-none">{{$t('about.newFeatureTitle3')}}</h1>
                <p class="" style="padding: 0 5%">{{$t('about.newFeatureP3')}}</p>
                <img class="mw-100 mt-5 d-xs-block d-lg-none" src="@/assets/images/about/tab_img3.png" alt="">
              </div>
            </div>
            <div v-show="currentTab === 3">
              <h1 class="tabs-title d-xs-block d-lg-none">{{$t('about.newFeatureTitle4')}}</h1>
              <div class="tabs-content">
                <img class="mw-100 m" src="@/assets/images/about/tab_img4.png" alt="">
                <h1 class="tabs-title d-lg-block d-xs-none">{{$t('about.newFeatureTitle4')}}</h1>
                <p>{{$t('about.newFeatureP4')}}</p>
              </div>
            </div>
          </app-feature-tabs>
        </div>
      </div>
      <img class="mw-100" src="@/assets/images/partner/bottom-Asset 17.png" alt="">
    </section>
    <section class="mt-app-registration-wrap">
      <div class="container">
        <div class="left-box">
          <h1>{{$t('home.member-Registration')}}</h1>
          <div class="mobile-wrap d-xs-none d-lg-block">
            <div class="mobile-wrap">
              <p>{{$t('home.member-Registration-intro')}}</p>
              <img class="m-phone-image" src="@/assets/images/about/mobile-p@2x.png" alt="">
              <div class="m-qr-box " style="display: flex; justify-content: center; column-gap: 15px;">
                <div style="width: 180px">
                  <img src="@/assets/images/home/N_appIcon.webp" class="mw-100 vertical-middle" style="width: 100%" alt="">
                </div>
                <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; width: 146px">
                  <img src="@/assets/images/home/NEW_PP_Asset 348@3x.png" class="mw-100" style="width: 100%" alt="">
                  <img style="margin-top: 5%; width: 100%" src="@/assets/images/home/NEW_PP_Asset 350@3x.png" class="mw-100" alt="">
                </div>
                <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; width: 146px">
                  <img src="@/assets/images/home/NEW_PP_Asset 348@3x.png" class="mw-100" style="width: 100%" alt="">
                  <img style="margin-top: 5%; width: 100%" src="@/assets/images/home/NEW_PP_Asset 351@3x.png" class="mw-100" alt="">
                </div>
              </div>
            </div>
          </div>
          <div class="reg-video-box">
            <div class="d-flex m" style="align-items: center; font-weight: bold">
              <img src="@/assets/images/home/Asset 409@2x.webp" style="width: 23px; margin-right:10px" alt="">
              {{$t('home.video-Tutorial')}}
            </div>
            <div class="re" style="margin-top: 3%">
              <h5>{{$t('home.video-registration')}}</h5>
              <div class="redemption-row">
                <div class="card" v-for="(card, index) in registrationCards" :key="`reg-${index}`" @click="openVideo(card.videoId)">
                  <img src="@/assets/images/home/Asset 411@2x.webp" class="mw-100" alt="">
                  <span v-html="card.title.replace(/\n/g, '<br>')"></span>
                </div>
              </div>
            </div>
            <el-divider style=""/>
            <div class="re">
              <h5>{{$t('home.video-redemption')}}</h5>
              <div class="redemption-row">
                <div v-for="(card, index) in redemptionCards" :key="`red-${index}`" class="card" @click="openVideo(card.videoId)">
                  <img src="@/assets/images/home/Asset 411@2x.webp" class="mw-100" :alt="card.title" />
                  <span v-html="card.title.replace(/\n/g, '<br>')"></span>
                </div>
              </div>
            </div>
            <el-divider/>
          </div>
          <h1 class="d-xs-block d-lg-none" style="margin-top: 10%;">{{$t('about.downApp')}}</h1>
          <div class="d-xs-block d-lg-none">
            <div class="qr-box " style="display: flex">
              <div style="width: 244px">
                <img src="@/assets/images/home/N_appIcon.webp" class="mw-100 vertical-middle" style="width: 100%" alt="">
                <h1></h1>
              </div>
              <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; width: 206px">
                <img src="@/assets/images/home/NEW_PP_Asset 348@3x.png" class="mw-100" style="width: 100%" alt="">
                <img style="margin-top: 5%; width: 100%" src="@/assets/images/home/NEW_PP_Asset 350@3x.png" class="mw-100" alt="">
              </div>
              <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; width: 206px">
                <img src="@/assets/images/home/NEW_PP_Asset 348@3x.png" class="mw-100" style="width: 100%" alt="">
                <img style="margin-top: 5%; width: 100%" src="@/assets/images/home/NEW_PP_Asset 351@3x.png" class="mw-100" alt="">
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>

    <CommonBottomBar/>
    <!-- YouTube Video Dialog -->
    <el-dialog
        :visible.sync="dialogVisible"
        @close="closeDialog"
        width="800"
        :show-close="false"
        :close-on-click-modal="false"
    >
      <div v-if="currentVideoId" class="video-container" style="height: 550px">
        <iframe
            :src="currentVideoId"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
            width="100%"
            height="100%"
        ></iframe>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">Close</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style scoped lang="scss">
@use '@/styles/responsive.scss' as *;
.about-container{
  width: 100%;
  .big-image{
    min-height: 70vh; /* 设置最小高度，确保布局稳定的同时允许内容扩展 */
    //display: flex;
    //align-items: center;
    //justify-content: center;
    overflow: hidden;
    position: relative;
    @include media-max(sm){
      min-height: 30vh;
    }
  }
  .about-wrap{
    display: flex;
    align-items: flex-start;
    //justify-content: center;
    //align-items: center;
    //flex-direction: column;
    margin-top: 7%;
    margin-bottom: 20%;
    column-gap: 229px;
    .left-wrap{
      flex: 1.5;
      h1{
        color: #158800;
        font-size: 45px;
        //line-height: 104px;
      }
      p{
        margin-top: 55px;
        font-size: 20px;
      }
    }
    .right-wrap{
      flex: .9;
      h1{
        font-size: 30px;
        color: #158800;
        margin-bottom: 5%;
      }
      .item{
        display: flex;
        align-items: flex-start;
        column-gap: 13px;
        font-size: 20px;
        .rs-title{
          color: #158800;
          font-weight: 600;
          margin-bottom: 10px;
        }
        .about-qr-box{
          display: flex;
          column-gap: 30px;
          img{
            width: 80%;
          }
        }
      }
    }

  }
  .mt-app-wrap{
    position: relative;
    .mt-app-intro-wrap{
      background: #fff9df;
      .top-box{
        display: flex;
        padding-bottom: 10%;
        .right-box{
          margin-left: auto;
          margin-right: 275px;
          max-width: 34%;
          text-align: center;
          padding-top: 110px;
          h1{
            color: #158800;
            font-size: 45px;
          }
          p{
            margin-top: 8%;
            font-size: 20px;
          }
        }
      }
      .app-feature-wrap{
        margin-top: 25px;
        padding-top: 78px;
        padding-bottom: 122px;
        display: flex;
        align-items: center;
        flex-direction: column;
        background-image:
            linear-gradient(135deg,
                rgba(255, 249, 221, 0.5) 25%,
                transparent 25%,
                transparent 50%,
                rgba(247, 240, 211, 0.5) 50%,
                rgba(255, 255, 255, 0.1) 75%,
                transparent 75%
            );
        background-size: 50px 50px;
        background-position: 0 0;
        h1{
          font-size: 45px;
        }
        .feature-items{
          margin-top: 100px;
          padding: 0 5%;
          display: flex;
          .item{
            padding: 20px 24px;
            text-align: center;
            border-right: 4px solid #ffcc24;
            font-size: 20px;
            line-height: 35px;
            min-width: 364px;
            max-width: 390px;
          }
        }
      }
    }
  }
  .mt-app-registration-wrap{
    margin-top: 36px;
    position: relative;
    display: flex;
    .left-box{
      //margin-left: 251px;
      max-width: 790px;
      h1{
        color: #158800;
        font-size: 45px;
      }
      .reg-video-box{
        margin-top: 62px;
        font-size: 20px;
        line-height: 32px;
        .re{
          padding-left: 5%;
          h5{
            font-size: 20px;
            line-height: 32px;
            color: #158800;
            margin-bottom: 2%;
          }
          .registration-grid{
            display: grid;
            grid-template-columns: repeat(2, 230px);
            gap: 31px 28px;
            justify-content: start;
          }
          .redemption-row{
            display: flex;
            gap: 28px;
            align-items: center;
            flex-wrap: wrap;
          }
          .card{
            position: relative;
            width: 230px;
            cursor: pointer;
            span{
              position: absolute;
              left: 30%;
              top: 50%;
              transform: translateY(-60%);
              font-size: 15px;
              line-height: 18px;
              color: #5A2A00;
            }

          }
        }
        .el-divider--horizontal{
          margin: 64px 0;
        }
      }
      .qr-box{
        margin-top: 92px;
        display: flex;
        column-gap: 90px;
      }
    }
  }
  @media (max-width: 1650px) {
    .mt-app-wrap{
      .mt-app-intro-wrap{
        >img{
          left: 100px !important;
        }
      }
    }
  }
  @include media-max(xxl){
    .about-wrap{
      padding: 0 55px;
      column-gap: 100px;
    }
    .mt-app-wrap{
      .mt-app-intro-wrap{
        .top-box {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding-bottom: 1%;
          margin-top: 200px;
          .phone-img{
            width: 30%;
            text-align: center;
            margin-top: -12%;
          }
          .right-box {
            text-align: center;
            margin: 0;
            margin-top: 40px;
            padding: 0 55px;
            max-width: 100%;
            //h1 {
            //  color: #158800;
            //  font-size: 45px;
            //}

            //p {
            //  margin-top: 8%;
            //  font-size: 20px;
            //}
          }
        }
      }
    }
    .mt-app-registration-wrap{
      .left-box{
        margin-left: 40px;
      }
    }
  }
  @include media-max(lg){
    margin-top: 108px;
    .about-wrap{
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .left-wrap{
        text-align: center;
        padding: 0 55px;
      }
      .right-wrap{
        h1{
          text-align: center;
        }
      }
    }
    .mt-app-wrap{
      .mt-app-intro-wrap {
        .top-box {
          .phone-img{
            width: 50%;
          }
        }
        .app-feature-wrap{
          margin-top: 25px;
          padding-top: 0;
          padding-bottom: 122px;
          display: flex;
          align-items: center;
          flex-direction: column;
          background-image: none;
          .feature-items{
            margin-top: 37px;
            padding: 0 55px;
            display: flex;
            flex-direction: column;
            .item{
              //4px solid #ffcc24
              padding: 10px 12px;
              border-right: none;
              font-size: 20px;
              min-width: 320px;
            }
            .divider {
              border: none;
              height: 4px;
              background-color: #FFD700;
              width: 30%;
              margin: 20px auto;
              border-radius: 2px;
            }
          }
        }
      }
    }
    .mt-app-registration-wrap{
      margin-top: 36px;
      position: relative;
      display: flex;
      .left-box{
        margin: 0;
        max-width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        .mobile-wrap{

          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          margin-top: 30px;
          p{
            padding: 0 55px;
            text-align: center;
          }
          .m-phone-image{
            align-self: flex-end;
          }
          .m-qr-box{
            margin: 15% 0 8%;
          }
        }
        h1{
          color: #158800;
          font-size: 45px;
          text-align: center;
        }
        .reg-video-box{
          margin-top: 62px;
          font-size: 20px;
          line-height: 32px;
          padding: 0 55px;
          .m{
            justify-content: center;
          }
          .re{
            padding-left: 0%;
            h5{
              font-size: 20px;
              line-height: 32px;
              color: #158800;
              margin-bottom: 5%;
              text-align: center;
            }
            .registration-grid{
              display: grid;
              grid-template-columns: repeat(2, 230px);
              gap: 31px 28px;
              justify-content: start;
            }
            .redemption-row{
              display: grid;
              grid-template-columns: repeat(2, 1fr);
              gap: 15px;
            }
            .card{
              position: relative;
              width: 230px;
              cursor: pointer;
              span{
                position: absolute;
                left: 30%;
                top: 50%;
                transform: translateY(-60%);
                font-size: 15px;
                line-height: 18px;
                color: #5A2A00;
              }

            }
          }
          .el-divider--horizontal{
            margin: 64px 0;
          }
        }
        .qr-box{
          margin-top: 92px;
          display: flex;
          column-gap: 90px;
        }
      }
    }
    ::v-deep(.el-dialog){
      width: 90% !important;
    }
    .video-container{
      height: 40vh !important;
    }
  }
  @include media-max(md){
    margin-top: 148px;
    .about-wrap{
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .left-wrap{
          text-align: center;
          p{
            font-size: 17px;
          }
        }
        .right-wrap{
          margin-top: 3%;
          .mobile-content{
            row-gap: 30px!important;
          }
          .item{
            p{
              font-size: 20px;
            }
          }
        }
      }
    .mt-app-wrap{
      .mt-app-intro-wrap {
        .top-box {
          .right-box {
            //h1 {
            //  color: #158800;
            //  font-size: 45px;
            //}

            p {
              font-size: 12px;
            }
          }
        }
        .app-feature-wrap{
          .feature-items{
            .item{
              //4px solid #ffcc24
              text-align: center;
              border-right: none;
              font-size: 16px;
              line-height: 29px;
              //min-width: 364px;
              //max-width: 390px;
            }
          }
        }
      }
    }
    .mt-app-registration-wrap{
      margin-top: 36px;
      position: relative;
      display: flex;
      .left-box{

        .mobile-wrap{
          .m-phone-image{
            align-self: flex-end;
          }
          .m-qr-box{
            div{
              width: 20% !important;
              &:first-child{
                width: 30% !important;
              }
            }
          }
        }
        h1{
        }
        .reg-video-box{
          margin-top: 62px;
          font-size: 20px;
          line-height: 32px;
          .m{
            justify-content: center;
          }
          .re{
            h5{
              font-size: 20px;
              line-height: 32px;
              color: #158800;
              //margin-bottom: 2%;
              text-align: center;
            }
            .registration-grid{
              display: grid;
              grid-template-columns: repeat(2, 230px);
              gap: 20px 22px;
              justify-content: start;
            }
            .redemption-row{
              display: grid;
              gap: 10px;
              grid-template-columns: repeat(2, 1fr);
            }
            .card{
              position: relative;
              //width: 230px;
              cursor: pointer;
              span{
                //font-size: 11px;
                //line-height: 18px;
                //color: #5A2A00;
              }

            }
          }
          .el-divider--horizontal{
            margin: 64px 0;
          }
        }
        .qr-box{
          margin-top: 92px;
          display: flex;
          column-gap: 90px;
        }
      }
    }
  }
  @include media-max(sm){
    margin-top: 111px;
    .about-wrap{
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .left-wrap{
          text-align: center;
          p{
            font-size: 12px;
          }
        }
        .right-wrap{
          .item{
            .about-qr-box{
              column-gap: 15px;
              div{
                width: 80px !important;
                img{
                  width: 100%;
                }
                &:first-child{
                  width: 100px !important;
                }
              }
            }
          }
        }
      }
    .mt-app-registration-wrap{
      margin-top: 36px;
      position: relative;
      display: flex;
      .left-box{

        .mobile-wrap{
          .m-phone-image{
            align-self: flex-end;
          }
        }
        h1{
        }
        .reg-video-box{
          margin-top: 62px;
          font-size: 20px;
          line-height: 32px;
          .m{
            justify-content: center;
          }
          .re{
            h5{
              font-size: 20px;
              line-height: 32px;
              color: #158800;
              //margin-bottom: 2%;
              text-align: center;
            }
            .registration-grid{
              display: grid;
              grid-template-columns: repeat(2, 230px);
              gap: 20px 22px;
              justify-content: start;
            }
            .redemption-row{
              display: grid;
              gap: 10px;
              grid-template-columns: repeat(2, 1fr);
            }
            .card{
              position: relative;
              width: 177px;
              cursor: pointer;
              span{
                font-size: 11px;
                line-height: 18px;
                color: #5A2A00;
              }

            }
          }
          .el-divider--horizontal{
            margin: 64px 0;
          }
        }
        .qr-box{
          margin-top: 92px;
          display: flex;
          column-gap: 90px;
        }
      }
    }
  }
}

/* 图片淡入动画 */
.fade-in-image{
  opacity: 0;
  animation: fadeIn 0.5s ease-in forwards;
}

/* 加载状态 */
.image-loading{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #009344;
}

.loading-icon{
  font-size: 48px;
  animation: rotate 2s linear infinite;
}

/* 淡入动画 */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* 旋转动画 */
@keyframes rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}


</style>
<style>
.el-image img{
  max-width: 100% !important;
}
</style>